module.exports = __webpack_public_path__ + "img/iconmonstr-phone-3-green.14f5ace8.svg";